import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferAppleMusicToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.transferAppleMusicToYoutube}
            sections={<PairTransferGuideContent sourceKey="appleMusic" destKey="youtube" />}
        />
    );
}
